import { render, staticRenderFns } from "./ConstToStar.vue?vue&type=template&id=16fa86f8&scoped=true&"
import script from "./ConstToStar.vue?vue&type=script&lang=ts&"
export * from "./ConstToStar.vue?vue&type=script&lang=ts&"
import style0 from "./ConstToStar.vue?vue&type=style&index=0&id=16fa86f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa86f8",
  null
  
)

export default component.exports